
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4957|5130|6341|9465)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
